var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "206px",
    height: "206px",
    viewBox: "0 0 206 206",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "chevron") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Phase-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M102.793108,169.450574 C99.519123,169.410921 96.2572607,168.142037 93.759145,165.643921 L93.759145,165.643921 L13.8560787,85.740855 C8.77926291,80.6640392 8.77926291,72.4328945 13.8560787,67.3560787 C18.9328945,62.2792629 27.1640392,62.2792629 32.240855,67.3560787 L32.240855,67.3560787 L102.999467,138.114467 L173.759145,67.3560787 C178.835961,62.2792629 187.067105,62.2792629 192.143921,67.3560787 C197.220737,72.4328945 197.220737,80.6640392 192.143921,85.740855 L112.240855,165.643921 C109.742739,168.142037 106.480877,169.410921 103.206892,169.450574 Z",
    id: "chevron",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.c4b267d1466361d16171167215d820d1.svg";
export { ForwardRef as ReactComponent };